module.exports = __webpack_public_path__ + "static/media/ophos-monitoring.2d8dd8e8.svg";